import { render, staticRenderFns } from "./OpinionRange.vue?vue&type=template&id=5cc84e38"
import script from "./OpinionRange.vue?vue&type=script&lang=js"
export * from "./OpinionRange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports